/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { TextFieldDisplay } from "./display";
import { TextFieldEdit } from "./edit";

const TextField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <TextFieldDisplay />,
        editComponent: <TextFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
TextField.displayName = "TextField";
export { TextField };
